import firebase from "firebase";
import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./views/Dashboard.vue";
import Login from "./views/Login.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      redirect: "/dashboard"
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // If route doesn't require auth, move along
  if (!requiresAuth) next();
  // If auth route && user is not loged in, redirect
  else if (!currentUser && requiresAuth) next("login");
  // Check to make sure the user has permissions
  else if (!(await adminCheck(currentUser))) next("login");

  next();
});

function adminCheck(currentUser) {
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("admins")
      .doc(currentUser.email)
      .get()
      .then(result => {
        resolve(result.exists);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export default router;
